import type { INotificationOptions } from '~/interfaces/INotification';
import type { SurveySectionScore } from '~/models/SurveySectionModel';
import { useSurveySectionStore } from '~/stores/use-survey-section.store';
import { useNotify } from './use-notify';

const SURVEY_MESSAGE_ERROR: INotificationOptions = {
  name: 'Не удалось отправить оценку, попробуйте позже',
  theme: 'error',
  position: 'bottom-right',
};

const SURVEY_MESSAGE_SUCCESS: INotificationOptions = {
  name: 'Ваша оценка успешно отправлена. Спасибо за обратную связь!',
  theme: 'success',
  position: 'bottom-right',
};

// Отправка оценки не запускает отслеживание прокрутки и не управляет модальными окнами.
export function useSurveyScore() {
  const context = useNuxtApp();
  const notify = useNotify();
  const store = useSurveySectionStore();

  async function setScore(score: SurveySectionScore): Promise<boolean> {
    try {
      await context.$services.surveySection.scoreAdd(score);
      store.setShown(true);
      notify.success(SURVEY_MESSAGE_SUCCESS);
      return true;
    } catch {
      notify.error(SURVEY_MESSAGE_ERROR);
      return false;
    }
  }

  return { setScore };
}
